<template>
  <div id="app-main" class="app-main">
    <div class="row">
      <div class="col-md-4 col-xl-2">
        <div class="widget-rounded-circle card-box">
          <div class="row-flex">
            <div class="avatar-lg rounded-circle bg-soft-primary border-primary border text-center">
              <span class="font-22 avatar-title text-primary">
                <span class="mdi mdi-gamepad-circle-outline"></span>
              </span>
            </div>
            <div class="flex-1 text-right">
              <h3 class="mt-1">
                <span data-plugin="counterup">
                  <numberGrow :value="courseStatsData.count || 0" :time="5"></numberGrow>
                </span>
              </h3>
              <p class="text-muted mb-1 text-truncate">图谱应用数</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 col-xl-2">
        <div class="widget-rounded-circle card-box">
          <div class="row-flex">
            <div class="avatar-lg rounded-circle bg-soft-warning border-warning border">
              <span class="font-22 avatar-title text-warning">
                <i class="fa fa-user"></i>
              </span>
            </div>
            <div class="text-right flex-1">
              <h3 class="text-dark mt-1">
                <span data-plugin="counterup">
                  <numberGrow :value="courseStatsData.student || 0" :time="5"></numberGrow>
                </span>
              </h3>
              <p class="text-muted mb-1 text-truncate">图谱使用人次</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 col-xl-2">
        <div class="widget-rounded-circle card-box">
          <div class="row-flex">
            <div class="avatar-lg rounded-circle bg-soft-info border-info border">
              <span class="font-22 avatar-title text-info">
                <i class="el-icon-share"></i>
              </span>
            </div>
            <div class="text-right flex-1">
              <h3 class="text-dark mt-1">
                <span data-plugin="counterup">
                  <numberGrow :value="courseStatsData.frame || 0" :time="5"></numberGrow>
                </span>
              </h3>
              <p class="text-muted mb-1 text-truncate">框架总数</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 col-xl-2">
        <div class="widget-rounded-circle card-box">
          <div class="row-flex">
            <div class="avatar-lg rounded-circle bg-soft-blue border-blue border">
              <i class="mdi mdi-flag font-22 avatar-title text-blue"></i>
            </div>
            <div class="text-right flex-1">
              <h3 class="text-dark mt-1">
                <span data-plugin="counterup">
                  <numberGrow :value="courseStatsData.indicator || 0" :time="5"></numberGrow>
                </span>
              </h3>
              <p class="text-muted mb-1 text-truncate">指标总数</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-xl-2">
        <div class="widget-rounded-circle card-box">
          <div class="row-flex">
            <div class="avatar-lg rounded-circle bg-soft-success border-success border">
              <span class="font-22 avatar-title text-success">
                <i class="fa fa-link"></i>
              </span>
            </div>
            <div class="text-right flex-1">
              <h3 class="text-dark mt-1">
                <span data-plugin="counterup">
                  <numberGrow :value="courseStatsData?.section || 0" :time="5"></numberGrow>
                </span>
              </h3>
              <p class="text-muted mb-1 text-truncate">指标关联主题</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-xl-2">
        <div class="widget-rounded-circle card-box">
          <div class="row-flex">
            <div class="avatar-lg rounded-circle bg-soft-danger border-danger border">
              <i class="mdi mdi-chat-processing font-22 avatar-title text-danger"></i>
            </div>
            <div class="text-right flex-1">
              <h3 class="text-dark mt-1">
                <span data-plugin="counterup">
                  <numberGrow :value="courseStatsData.activity || 0" :time="5"></numberGrow>
                </span>
              </h3>
              <p class="text-muted mb-1 text-truncate">指标关联评价项</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-row>
      <el-col>
        <div class="pb-2">
          <div class="two-charts-box">
            <div class="card-box">
              <div class="chart-title">能力词云图</div>
              <div id="ability-cloud-charts" :style="{ height: '400px' }"></div>
            </div>
            <div class="card-box">
              <div class="chart-title">图谱建设情况</div>
              <div id="graph-build-charts" :style="{ height: '400px' }"></div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { toThousands } from '@/utils/format.js'
import NumberGrow from '@/components/NumberGrow.vue'
import 'echarts-wordcloud'
import { imgCloudBase64 } from '@/utils/image.js'
export default {
  components: {
    NumberGrow,
  },
  data() {
    return {
      abilityCloudCharts: null,
      platFormChart: null,
      courseAndPlatFormChart: null,
      screenWidth: '',
      screenHeight: '',
      termData: [],
      courseStatsData: {},
      showData: false,
      curOnlineStudent: 0,
      curOnlineCourse: 0,
      updateTimer: null,
    }
  },
  filters: {
    filterTotalNum(val) {
      return toThousands(val)
    },
  },
  watch: {
    screenWidth() {
      this.getReSize()
    },
  },
  computed: {
    curEnv() {
      return process.env.VUE_APP_MODE
    },
    termLength() {
      return this.termData.length
    },
    courseData() {
      let x = []
      let y = []
      let data = {}
      for (let i of this.termData) {
        x.push(i.title)
        y.push(i.course)
      }
      data['x'] = x
      data['y'] = y
      return data
    },
    platformData() {
      let x = []
      let y = []
      let data = {}
      for (let i of this.termData) {
        x.push(i.title)
        y.push(i.pv)
      }
      data['x'] = x
      data['y'] = y
      return data
    },
  },
  mounted() {
    this.handleGetCapabilityTotal()
    this.screenWidth = document.body.clientWidth //监听页面缩放
    this.screenHeight = document.body.clientHeight
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
        this.screenHeight = document.body.clientHeight
      })()
    }
  },
  beforeDestroy() {
    if (this.updateTimer) {
      clearInterval(this.updateTimer)
    }
  },
  methods: {
    toThousands,
    // 更多数据按钮
    showDetailData() {
      this.showData = !this.showData
    },
    // 查看实时在线人数
    checkOnlineUser() {
      console.log('查看在线')
      this.$router.push({ path: '/platform/userOnline' })
    },
    // 查看实时在线课程
    checkOnlineCourse() {
      console.log('查看课程')
      this.$router.push({ path: '/platform/courseOnline' })
    },
    // 学期数据接口
    async getSemesterDataApi() {
      await this.$store
        .dispatch('platform/getSemesterData')
        .then((res) => {
          console.log('res:', res)
          if (res.code === 1) {
            if (res.data.length) {
              this.termData = res.data
              console.log('termData', this.termData)
              this.handleGetCapabilityTotal()
              this.iniCourseChart(this.courseData)
            } else {
              this.termData = []
            }
          }
        })
        .catch((err) => {
          return Promise.reject(err)
        })
    },
    // 获取总体概况
    handleGetCapabilityTotal() {
      this.$store
        .dispatch('capability/getCapabilityTotal')
        .then((res) => {
          console.log('handleGetCapabilityTotal res', res)
          this.courseStatsData = res.data
          let voiceWordTop = res.data?.cloud?.map((item) => {
            return {
              name: item.indicator_name,
              value: item.reference_count,
            }
          })
          this.initClassroomThinkingWordCloud(voiceWordTop)
          this.iniCourseChart()
        })
        .catch((err) => {
          console.log('err', err)
        })
    },
    // 课堂高频词
    initClassroomThinkingWordCloud(voiceWordTop = []) {
      var myChart = this.$echarts.init(document.getElementById('ability-cloud-charts'))
      // 求出最大值用来计算透明度
      var max = 0
      // 方法一
      for (let item of voiceWordTop) {
        if (item.value > max) {
          max = item.value
        }
      }
      console.log('imgCloudBase64', imgCloudBase64);
      const maskImage = new Image()
      maskImage.src = imgCloudBase64
      // 这里是官方给出的一些基本的配置项，我做一些说明
      let option = {
        series: [
          {
            // maskImage: maskImage,
            type: "wordCloud", //类型是词云图
            shape: "rectangle", //词云图的形状为矩形圆形
            keepAspect: false, //不保持词云图的纵横比
            //词云图的位置和大小
            left: "center",
            top: "center",
            width: "100%",
            height: "100%",
            right: null,
            bottom: null,
            sizeRange: [12, 50], //词云图中词语的字体大小范围，最小12px，最大60px
            rotationRange: [0, 45], //词云图中词语的旋转角度范围
            rotationStep: 45, //词云图中词语的旋转步长
            gridSize: 10, //词云图中词语的间距
            drawOutOfBound: false, //不绘制超出词云图范围的词语
            layoutAnimation: true, //开启布局动画
            //词云图中词语的样式
            textStyle: {
              fontWeight: "bold",
              // color: 指定词条颜色, 可是颜色字符串，如 red、#ff0000设置所有词条为同一颜色，也可指定函数动态设置每个词条颜色
              color: function () {
                return (
                  "rgb(" +
                  [
                    Math.round(Math.random() * 160),
                    Math.round(Math.random() * 160),
                    Math.round(Math.random() * 160),
                  ].join(",") +
                  ")"
                );
              },
            },
            // 词云图中词语的高亮样式
            emphasis: {
              textStyle: {
                textShadowBlur: 2,
                textShadowColor: "orange",
              },
            },
            data: voiceWordTop,
          },
        ],
      }
      const _this = this
      maskImage.onload = () => {
        myChart.setOption(option)
        _this.abilityCloudCharts = myChart
      }
    },
    iniCourseChart() {
      var chart = this.$echarts.init(document.getElementById('graph-build-charts'))
      let xAxisData = []
      let yAxisData = []
      let stuYAxisData = []
      let stuMax = 10
      this.courseStatsData?.semester?.forEach((item) => {
        xAxisData.push(item.semester_name)
        yAxisData.push(item.count)
        stuYAxisData.push(item.count_stud)
        if(item.count_stud > stuMax) {
          stuMax = item.count_stud
        }
      })
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        xAxis: {
          type: 'category',
          data: xAxisData,
          axisLabel: {
            interval: 0,
          },
        },
        yAxis: [
          {
            type: 'value',
            name: '图谱个数',
            minInterval: 1,
            nameTextStyle: {
              color: '#98a6ad',
              padding: [0, 50, 30, 0],
              fontSize: '12',
              align: 'center',
            },
          },
          {
            type: 'value',
            name: '使用学生次数',
            min: 0,
            max: stuMax,
            splitLine: {
              show: false
            }
          },
        ],
        series: [
          {
            name: '图谱个数',
            data: yAxisData,
            type: 'bar',
            itemStyle: {
              color: '#409EFF',
            },
          },
          {
            name: '使用学生次数',
            type: 'line',
            yAxisIndex: 1,
            data: stuYAxisData,
            itemStyle: {
              color: '#FA9A34',
            },
          },
        ],
      }
      chart.setOption(option)
      this.abilityCloudCharts = chart
    },
    iniPlatformChart(data) {
      var chart = this.$echarts.init(document.getElementById('graph-build-charts'))
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        xAxis: {
          type: 'category',
          data: data.x,
          axisLabel: {
            interval: 0,
          },
        },
        yAxis: {
          type: 'value',
          name: '人数',
          minInterval: 1,
          nameTextStyle: {
            color: '#98a6ad',
            padding: [0, 30, 30, 0],
            fontSize: '12',
            align: 'center',
          },
        },
        series: [
          {
            data: data.y,
            type: 'bar',
            itemStyle: {
              color: '#44CF9C',
            },
          },
        ],
      }
      chart.setOption(option)
      this.platFormChart = chart
    },
    getReSize() {
      let chartArr = [this.abilityCloudCharts, this.platFormChart, this.courseAndPlatFormChart]
      for (let i = 0; i < chartArr.length; i++) {
        //此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
        setTimeout(function () {
          if (chartArr[i]) {
            chartArr[i].resize()
          }
        }, 200)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.app-main {
  padding-top: 30px;
}
.all-counts {
  font-size: 26px;
}
.el-tooltip.item {
  cursor: pointer;
}
.tooltip-content {
  font-size: 14px;
  line-height: 21px;
}
.first-row.online {
  margin: 0;
  & > div {
    cursor: pointer;
  }
}
.total-number {
  font-size: 28px;
  font-weight: bold;
  color: #343a40;
}
.page-title-box {
  h4.page-title {
    font-weight: 600;
  }
  .date-range {
    color: rgba(108, 117, 125, 1);
    font-size: 14px;
  }
}
.row-flex {
  display: flex;
  .rounded-circle {
    margin-right: 10px;
    min-width: 70px;
  }
  .flex-1 {
    flex: 1;
    width: 0;
  }
}
.first-row-card {
  padding: 36px 0;
  .first-row {
    position: relative;
    .more-data-box {
      position: absolute;
      right: 34px;
      top: -30px;
    }
    .detail-box {
      padding: 5px 10px;
      background: #f8fafc;
      border-radius: 4px;
      .detail {
        font-size: 14px;
        color: #6c757d;
        line-height: 21px;
        white-space: nowrap;
      }
    }
  }
}

.real-time-box {
  background: url('~@/assets/images/common/img_live_leftdown.png') left bottom no-repeat,
    url('~@/assets/images/common/img_live_rightup.png') right top no-repeat;
  background-origin: padding-box;
  background-color: rgba(50, 148, 246, 0.25);
}
.chart-title {
  margin-bottom: 36px;
  font-size: 16px;
  font-weight: bold;
  color: #343a40;
}
.single-chart-box {
  .card-box {
    width: 100%;
  }
}
.real-time-nums.col-sm-6.col-md-6.col-lg-6.col-xl-6 {
  margin-top: 6px;
  margin-bottom: 6px;
}
@media screen and (max-width: 1200px) and (min-width: 991px) {
  .first-row-card {
    .first-row {
      .col-sm-6.col-xl-3 {
        flex: 0 0 50%;
        max-width: 50%;
      }
    }
  }
}
@media screen and (max-width: 2120px) and (min-width: 1367px) {
  .col-fix1-1367-1900.col-sm-12.col-xl-8 {
    flex: 0 0 80%;
    max-width: 80%;
  }
  .col-fix2-1367-1900.col-sm-12.col-xl-8 {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .first-row-card {
    .first-row {
      .col-sm-6.col-xl-3 {
        flex: 0 0 50%;
        max-width: 50%;
      }
    }
  }
  .real-time-nums.col-sm-6.col-md-6.col-lg-6.col-xl-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .real-time-courses.col-sm-6.col-md-6.col-lg-6.col-xl-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media screen and (min-width: 1900px) {
  .col-fix1-1367-1900.col-sm-12.col-xl-8 {
    flex: 0 0 66.66666%;
    max-width: 66.66666%;
  }
  .col-fix2-1367-1900.col-sm-12.col-xl-8 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }
}
</style>
